<template lang="pug">
  div
    v-container(fluid, grid-list-md)
      v-layout(row, wrap)
        v-flex(xs12)
          v-card
            v-card-text
              .text-xs-center.py-5(v-if='!listImageURL || listImageURL.length < 1')
                .headline {{ $t('messages.noMediaFound') | capitalize }}
              v-container(v-else fluid)
                v-layout(row, wrap, align-center)
                  v-flex(md8)
                    h2 {{ gestationInteraction.patient.name }} ({{ gestationInteraction.patient.patId }}) - {{ gestationInteraction.date | formatDateExtend }}
                  v-flex(md4)
                    v-btn(@click="selectAll()") Selecionar todas
                    v-menu(offset-y)
                      template(v-slot:activator="{ on }")
                        v-btn(v-on="on") Imprimir
                      v-list
                        v-list-tile(@click="printImages(4,5)") 4x5
                        v-list-tile(@click="printImages(3,5)") 3x5
                        v-list-tile(@click="printImages(3,4)") 3x4
                        v-list-tile(@click="printImages(2,4)") 2x4
                        v-list-tile(@click="printImages(2,3)") 2x3
                        v-list-tile(@click="printImages(1,2)") 1x2
                    // Botão de exclusão - visível apenas para administradores
                    v-btn(
                      v-if="isAdmin"
                      color="error"
                      @click="confirmDelete = true"
                      :loading="deleting"
                      style="margin-left: 8px"
                    )
                      v-icon(left) delete
                      | Excluir tudo
                    div(style='display: none')
                      div( v-if="itemsPerPage" id="print-area" style='width: 800px;')
                        div(v-for="(group, groupIndex) in groupedImages" :key="groupIndex" class="image-group" style="margin-bottom: 20px;")
                          img(:src="item" v-for="(item, index) in group" :key="index" :width="imageSize" style="padding: 2px;")
                v-layout(row, wrap)
                  v-flex(v-for='(image, i) in listImageURL', :key='image', xs12, md4)
                    v-card(flat, tile)
                      v-layout(row, wrap)
                        v-flex(md2)
                          v-checkbox(v-model="selected" :value="image" hide-details)
                        v-flex(md10 style="text-align: right")
                          v-icon(@click.prevent="downloadDicom(image)" style="padding-top: 16px") download
                      v-img(:src='image', @click='slideIndex = i', style='background-color: black; height: 250px;')
                        v-layout(slot='placeholder', fill-height, align-center, justify-center, ma-0)
                          v-progress-circular(indeterminate, color='grey lighten-5')
                  vue-gallery(:images='listImageURL', :index='slideIndex', @close='slideIndex = null')

    // Diálogo de confirmação de exclusão
    v-dialog(v-model="confirmDelete" max-width="400")
      v-card
        v-card-title Confirmar Exclusão
        v-card-text
          p Você está prestes a excluir este estudo:
          p 
            strong Paciente: 
            | {{ gestationInteraction.patient.name }}
          p 
            strong Data: 
            | {{ gestationInteraction.date | formatDateExtend }}
          p(class="red--text") Esta ação não pode ser desfeita.
        v-card-actions
          v-spacer
          v-btn(
            text
            @click="confirmDelete = false"
            :disabled="deleting"
          ) Cancelar
          v-btn(
            color="error"
            @click="deleteStudy"
            :loading="deleting"
          ) Excluir
</template>

<script>
import VueGallery from 'vue-gallery'
import { mapState } from 'vuex'
import print from 'print-js'
import DropFile from '@/components/util/DropFile'
import axios from 'axios'
const getImageURL = 'https://app.ultrahealth.care/functions/healthcareImage?id='
const deleteStudyURL = 'https://app.ultrahealth.care/functions/healthcareDeleteStudy'

export default {
  name: 'Viewer',

  components: {
    VueGallery,
    DropFile
  },

  props: {
    id: {
      type: String
    }
  },

  computed: {
    ...mapState({
      dicomParams: state => state.ultraFetal.dicomParams,
      patient: state => state.ultraFetal.patient,
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction,
      company: state => state.ultraFetal.company,
      user: state => state.user
    }),
    isAdmin () {
      return this.user && this.user.role === 'admin'
    },
    listImageURL () {
      // Cria um objeto para agrupar os itens por StudyDescription
      const grouped = {}
      // Percorre todos os itens da lista dicomParams
      this.dicomParams.forEach(item => {
        // Pega o StudyDescription do item, ou 'Desconhecido' se não existir
        const StudyDescription = item.StudyDescription || 'Desconhecido'
        // Se ainda não existir um grupo com esse StudyDescription, cria um array vazio
        if (!grouped[StudyDescription]) {
          grouped[StudyDescription] = []
        }
        // Adiciona o item ao grupo correspondente
        grouped[StudyDescription].push(item)
      })
      Object.keys(grouped).forEach(StudyDescription => {
        // Ordena os itens dentro do grupo com base no InstanceNumber (em ordem crescente)
        grouped[StudyDescription].sort((a, b) => a.InstanceNumber - b.InstanceNumber)
      })
      // Junta todos os grupos em uma única lista ordenada
      const ordered = Object.values(grouped).flat()
      // Retorna uma lista com as URLs das imagens, concatenando getImageURL com o iuid de cada item
      return ordered.map(item => getImageURL + item.iuid)
    },
    groupedImages () {
      const groups = []
      for (let i = 0; i < this.selected.length; i += this.itemsPerPage) {
        groups.push(this.selected.slice(i, i + this.itemsPerPage))
      }
      return groups
    }
  },

  data () {
    return {
      studies: [{}],
      slideIndex: null,
      selected: [],
      imageSize: '24%',
      itemsPerPage: null,
      confirmDelete: false,
      deleting: false
    }
  },

  mounted () {
    this.loadGestationInteraction()
  },

  beforeDestroy () {
    this.$store.dispatch('ultraFetal/unsubscribe', 'GestationInteraction')
  },

  methods: {
    loadGestationInteraction () {
      console.log('loadGestationInteraction')
      this.$store.dispatch('ultraFetal/getGestationInteraction', this.id).then(data => {
        if (!this.dicomParams || !this.dicomParams.iuid) {
          // const interationDateKey = 'gestationalAge.info.interationDate'
          if (data.studyDate) {
            this.$store.dispatch('ultraFetal/getDicomParams', { identity: data.company.identity, patId: data.patient.patId, date: data.date, studyDate: data.studyDate })
          } else {
            this.$store.dispatch('ultraFetal/getDicomParams', { identity: data.company.identity, patId: data.patient.patId, date: data.date })
          }
        }
      })
    },

    printImages (column, row) {
      let size = Math.trunc(539.74 / (column + 4.29 * row - 3.59))
      this.imageSize = size + '%'
      this.itemsPerPage = row * column
      setTimeout(() => {
        print({
          printable: 'print-area',
          type: 'html',
          header: this.gestationInteraction.company.name,
          style: `img { padding: 2px} .image-group { page-break-after: always; }`,
          showModal: true,
          modalMessage: 'Gerando impressão...'
        })
      }, 50)
    },
    downloadDicom (url) {
      window.location.href = url.replace('healthcareImage', 'healthcareDicom')
    },
    selectAll () {
      if (this.selected.length === this.listImageURL.length) {
        this.selected = []
      } else {
        this.selected = this.listImageURL
      }
    },
    async deleteStudy () {
      try {
        this.deleting = true
        console.log(this.gestationInteraction.company.identity)
        console.log(this.dicomParams[0])
        const info = this.dicomParams[0].info
        const payload = {
          dicomStoreId: info.dicomStoreId,
          studyUid: info.studyUid
        }

        await axios.post(deleteStudyURL, payload)
        // swal
        this.$swal.fire({
          title: 'Sucesso',
          text: 'Estudo excluído com sucesso',
          icon: 'success'
        })
        // reload gestationInteraction
        this.loadGestationInteraction()
      } catch (error) {
        console.log(error)
        this.$swal.fire({
          title: 'Erro',
          text: 'Erro ao excluir o estudo',
          icon: 'error'
        })
      } finally {
        this.deleting = false
        this.confirmDelete = false
      }
    }
  }
}
</script>

<style>
  .blueimp-gallery-display {
    display: none;
  }
  .image-group {
    page-break-after: always;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Viewer.vue